const dreamList = [
    {
        id: 0,
        title: "Gorgon, 2023",
        image: require("./assets/tile-1.webp"),
        measurement: '33cm x 41cm',
        description: 'red stoneware, white slip, copper oxide, lead glaze',

    },
    {
        id: 1,
        title: "Dreamscape, 2022",
        image: require("./assets/tile-2.webp"),
        measurement: '47.8cm x 82cm',
        description: 'black clay, white slip, tin glaze; stoneware mounted with nails on paper and plywood',

    },
    {
        id: 2,
        title: "Meander, 2017",
        image: require("./assets/tile-3.webp"),
        image2: require("./assets/tile-4.webp"),
        class: 'scale-75 lg:scale-90',
        measurement: '240cm x 360cm',
        description: 'black clay, white slip, copper oxide, clear lead glaze',

    },
    {
        id: 3,
        title: "River Dee, 2020",
        image: require("./assets/tile-5.webp"),
        measurement: '58 cm x 43cm',
        description: 'white clay, copper oxide, clear glaze',

    },
    {
        id: 4,
        title: "The Portland Vase Across A Vine, 2018",
        image: require("./assets/tile-6.webp"),
        measurement: '43cm x 29.5cm',
        description: 'white clay, traces of red clay, cobalt oxide, clear glaze',

    },
    {
        id: 5,
        title: "Swimming Pool, 2019",
        class: 'scale-75 md:scale-100',
        image: require("./assets/pool.webp"),
        measurement: '200cm x 117cm x 1.7cm, each of ten panels',
        description: 'nylon fibre reinforced concrete',

    },
    {
        id: 6,
        title: "Whisteria Upside Down, 2019",
        image: require("./assets/wisteria.webp"),
        measurement: '177cm x 77cm',
        description: 'white clay, copper oxide, clear glaze',

    },
    {
        id: 7,
        title: "Fireplace, 2020",
        image: require("./assets/fireplace.webp"),
        measurement: 'Panel 134cm x 160cm',
        class: 'scale-75 md:scale-100',
        description: 'terracotta, white slip, copper oxide, lead glaze',

    },
    

]

export default dreamList;